import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@morningstar/shared/environment';
import { DashboardItem } from '../dashboard-item';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable()
export class DashboardService {

  dashboard$ = this.httpClient.get<DashboardItem[]>(this.baseHref + environment.api.dashboard.get)
                              .pipe(catchError(this.handleError));

  menu$ = this.httpClient.get<DashboardItem[]>(this.baseHref + environment.api.dashboard.menu)
                         .pipe(catchError(this.handleError));

  constructor(private httpClient: HttpClient, @Inject('API_BASE_URL') private baseHref: string) { }

  put(component: DashboardItem): Observable<any> {
    return this.httpClient.put<any>(this.baseHref + environment.api.dashboard.put, component)
                          .pipe(catchError(this.handleError));
  }

  delete(component: string): Observable<any> {
    return this.httpClient.delete<any>(this.baseHref + environment.api.dashboard.delete.replace('{component}', component))
                          .pipe(catchError(this.handleError));
  }

  sort(components: DashboardItem[]): Observable<any> {
    return this.httpClient.put<any>(this.baseHref + environment.api.dashboard.sort, components)
                          .pipe(catchError(this.handleError));
  }

  private handleError(err: any) {
    // TODO: send the server to some remote logging infrastructure
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `${err.status}: ${err.body.error}`;
    }

    return throwError(errorMessage);
  }
}
